import { VideoCameraOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { useEffect, useRef, useState } from "react";
import { GetRequest } from "../../utils/api";
import CustomLoader from "../loader";

interface Props {
    src: any;
    onPreviewClosed: Function;
    title?: string;
    URLloaded: boolean;
    modelOpen?: boolean;
}
const VideoComponent: React.FC<Props> = ({ src, onPreviewClosed, title, URLloaded }: Props) => {

    const videoSrc = useRef(src);
    const [loading, setLoading] = useState<boolean>(false);

    const [open, setopen] = useState<boolean>(false);
    useEffect(() => {
        if (URLloaded) {
            setopen(true);
            setLoading(false);
        }

    }, []);



    const fetchVideo = async (ev:any) => {

        ev.stopPropagation();

        setLoading(true);
        setopen(true);
        const response = await GetRequest(src + title, 'arraybuffer');

        let blob = new Blob([response], { type: 'image/jpeg' });
        videoSrc.current = URL.createObjectURL(blob);
        setLoading(false);

    }

    return (
        <>
            <VideoCameraOutlined rev={undefined} className="text-2xl m-2" onClick={(ev:any) => fetchVideo(ev)}></VideoCameraOutlined>
            <Modal title={"Video"} open={open} onCancel={() => { setopen(false); onPreviewClosed(); }} closable={true} footer={null}>
                {!loading ? <video className="w-100 h-100" controls>
                    <source src={videoSrc.current} type="video/mp4" />
                    Your browser does not support the video tag, Please install a modern browser.
                </video> : <CustomLoader size="lg"></CustomLoader>}
            </Modal>
        </>

    )
}

export default VideoComponent;